import { combineReducers } from 'redux';
import {
    REQUEST_EVENTS,
    RECEIVE_EVENTS,
    RECEIVE_1PAGE_EVENTS,
    RECEIVE_SINGLE_EVENT,
    EVENTS_PAGE_COUNT,
    CREATE_EVENT,
    DELETE_EVENT, STOP_FETCHING_EVENTS,
} from "./actions";


const isEventsFetching = (state = 0, data = {}) => {
    switch (data.type) {
        case REQUEST_EVENTS:
            return true
        case RECEIVE_EVENTS:
        case RECEIVE_1PAGE_EVENTS:
        case RECEIVE_SINGLE_EVENT:
        case STOP_FETCHING_EVENTS:
            return false
        default:
            return state;
    }
}

const items = (state = [], action = 0) => {
    switch (action.type) {
        case REQUEST_EVENTS:
            return state
        case RECEIVE_EVENTS:
            if (Array.isArray(action.events)) {
                const newState = [...state];
                action.events.forEach(event => {
                    if (!newState.some(item => item.id === event.id)) {
                        newState.push(event);
                    }
                });
                return newState;
            } else {
                return state.some(item => item.id === action.events.id)
                    ? state
                    : [...state, action.events];
            }
        case RECEIVE_1PAGE_EVENTS:
            return action.events;
        case CREATE_EVENT:
            return [action.event, ...state];
        case DELETE_EVENT:
            return state;
        default:
            return state;
    }
}

const singleEvent = (state = {}, action ) => {
    switch (action.type) {
        case RECEIVE_SINGLE_EVENT:
            return action.payload;
        default:
            return state;
    }
}

const hasMore = (state = false, action = 0) => {
    switch (action.type) {
        case REQUEST_EVENTS:
            return true
        case RECEIVE_EVENTS:
        case RECEIVE_1PAGE_EVENTS:
            return action.events.length >= EVENTS_PAGE_COUNT;
        default:
            return state;
    }
}

export const getEvents = (state) => state.items;
export const getSingleEvent = (state) => state.singleEvent;
export const getEventsFetching = (state) => state.isEventsFetching
export const getEventsHasMore = (state) => state.hasMore

const events = combineReducers({
    items, isEventsFetching, hasMore, singleEvent
})

export default events;